export const StreamingActionTypes = {
    GET_APP_TOKEN_REQUEST: "@@Agoro/GET_APP_TOKEN_REQUEST",
    GET_APP_TOKEN_SUCCESS: "@@Agoro/GET_APP_TOKEN_SUCCESS",
    GET_APP_TOKEN_FAILURE: "@@Agoro/GET_APP_TOKEN_FAILURE",

    CREATE_ROOM_REQUEST: "@@Agoro/CREATE_ROOM_REQUEST",
    CREATE_ROOM_SUCCESS: "@@Agoro/CREATE_ROOM_SUCCESS",
    CREATE_ROOM_FAILURE: "@@Agoro/CREATE_ROOM_FAILURE",

    GET_SESSIONS_REQUEST: "@@Agoro/GET_SESSIONS_REQUEST",
    GET_SESSIONS_SUCCESS: "@@Agoro/GET_SESSIONS_SUCCESS",
    GET_SESSIONS_FAILURE: "@@Agoro/GET_SESSIONS_FAILURE",
};
